import React from 'react';

const getMealTypeStyle = (mealType) => {
  switch (String(mealType || '').toLowerCase()) {
    case 'breakfast': return { icon: 'fa-sun', color: '#f59e0b' };
    case 'lunch': return { icon: 'fa-cloud-sun', color: '#3b82f6' };
    case 'dinner': return { icon: 'fa-moon', color: '#8b5cf6' };
    case 'snack': return { icon: 'fa-cookie-bite', color: '#10b981' };
    default: return { icon: 'fa-utensils', color: '#8b5cf6' };
  }
};

/**
 * Compact meal pills for month-view calendar cells.
 * Pills truncate to the cell width; the cell size is owned by CSS so
 * planned days cannot stretch the grid.
 */
const MonthDayMeals = ({ meals = [], maxPills = 3, getMealName, onMealClick }) => {
  const visible = meals.slice(0, maxPills);
  const extra = meals.length - visible.length;

  return (
    <div className="mp-month-meals">
      {visible.map((meal) => {
        const style = getMealTypeStyle(meal.mealType);
        const name = getMealName(meal);
        return (
          <div
            key={meal._id || meal.id}
            className="mp-month-meal-pill"
            style={{ borderLeftColor: style.color }}
            onClick={(e) => {
              e.stopPropagation();
              onMealClick?.(meal, e);
            }}
            title={name}
          >
            <i className={`fas ${style.icon}`} style={{ color: style.color }} aria-hidden="true"></i>
            <span>{name}</span>
          </div>
        );
      })}
      {extra > 0 && <div className="mp-month-more">+{extra}</div>}
    </div>
  );
};

export default MonthDayMeals;
